<template>
  <div class="page-content" v-if="listMap[this.categoryId]">
    <Item
      v-for="item in listMap[this.categoryId].data"
      :key="item.id"
      :item="item"
    ></Item>
    <div class="z-pagination" v-if="listMap[this.categoryId].total">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="listMap[this.categoryId].current_page"
        :page-size="listMap[this.categoryId].per_page"
        layout="prev, pager, next"
        :total="listMap[this.categoryId].total"
      >
      </el-pagination>
      <span class="z-pagination__total">
        共 {{ listMap[this.categoryId].total }} 条
      </span>
    </div>
  </div>
</template>

<script>
import Item from "./Item.vue";
export default {
  components: {
    Item,
  },
  props: {
    // list: {
    //   type: Array,
    //   default: () => [],
    // },
    listMap: {
      type: Object,
      default: () => ({}),
    },
    categoryId: {
      type: [Number, String],
      required: true,
    },
    // total: {
    //   type: Number,
    //   default: 0,
    // },
    // currentPage: {
    //   type: Number,
    //   default: 1,
    // },
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit("currentChange", page);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
}
</style>
